import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { AtributosIrfe } from 'src/app/shared/models/atributos-irfe.model';


@Injectable({
  providedIn: 'root',
})
export class AtributosIrfeService extends BaseService<AtributosIrfe>{

  constructor(public http: HttpClient) {
    super(http)
  }

  public getPathModule(): string {
    return '/atributos-irfe';
  }
}
